<template>
	<SignupForm agreement="https://api.onesun.com/os_agreement.html" />
</template>

<script>
	import SignupForm from "../shared/SignupForm.vue"

	export default {
		components: {
			SignupForm
		}
	}
</script>